<template>
    <ion-header>
        <ion-toolbar>
            <ion-buttons slot="start">
                <ion-back-button></ion-back-button>
            </ion-buttons>
            <ion-title>Seleziona una frequenza per le ispezioni</ion-title>

            <ion-buttons slot="end">
                <ion-nav-link router-direction="forward" :component="CostumerForm" :componentProps="cleanedData">
                    <ion-button
                        :disabled="isInterventionStoreLoading || selectedInterventionFrequency == undefined"
                        :strong="true">
                        Salva
                    </ion-button>
                </ion-nav-link>
            </ion-buttons>
        </ion-toolbar>
        <ion-toolbar>
            <ion-searchbar
                ref="searchbar"
                id="places-autocomplete-searchbar"
                v-model="search"
                placeholder="Cerca..."></ion-searchbar>
        </ion-toolbar>
    </ion-header>
    <ion-content style="--background: var(--ion-item-background)">
        <template v-if="!isInterventionStoreLoading">
            <template v-if="interventionFrequencies.length > 0">
                <ion-item-sliding v-for="intfreq in interventionFrequencies">
                    <ion-item
                        style="
                            --inner-padding-bottom: 8px;
                            --inner-padding-top: 8px;
                            --padding-top: 0px;
                            --padding-bottom: 0px;
                        "
                        @click="onFrequencySelect(intfreq)"
                        class="relative ion-activatable ripple-parent">
                        <ion-checkbox
                            style="pointer-events: none"
                            :checked="selectedInterventionFrequency == intfreq.id"
                            :aria-label="`select trap-${intfreq.id}`"
                            slot="start"></ion-checkbox>
                        <div>
                            <ion-label>{{ intfreq.description }}</ion-label>
                            <small>
                                <em>
                                    {{ intfreq.recent_inspection_interval }} -
                                    {{ intfreq.regular_situation_interval }} - {{ intfreq.expiring_situation_interval }}
                                </em>
                            </small>
                        </div>
                        <ion-ripple-effect></ion-ripple-effect>
                    </ion-item>
                    <ion-item-options side="end">
                        <ion-item-option
                            color="primary"
                            @click="intfreq?.id ? editInterventionFrequency(intfreq.id) : null">
                            <ion-icon slot="start" :icon="createOutline"></ion-icon>
                            Modifica
                        </ion-item-option>
                    </ion-item-options>
                </ion-item-sliding>
            </template>
            <template v-else>
                <div class="flex justify-center ion-margin-top">
                    <ion-note>
                        <small><em>Nessun risultato</em></small>
                    </ion-note>
                </div>
            </template>

            <ion-nav-link
                slot="fixed"
                style="bottom: 16px; right: 16px"
                router-direction="forward"
                :component="InterventionFrequencyForm">
                <ion-fab-button>
                    <ion-icon :icon="add"></ion-icon>
                </ion-fab-button>
            </ion-nav-link>
        </template>
        <template v-else>
            <ion-item class="costumer-list-item" v-for="_ in [1, 2, 3, 4, 5, 6, 7, 8, 9]">
                <ion-label>
                    <h3>
                        <ion-skeleton-text :animated="true" style="width: 80%"></ion-skeleton-text>
                    </h3>
                    <p>
                        <ion-skeleton-text :animated="true" style="width: 60%"></ion-skeleton-text>
                    </p>
                    <p>
                        <ion-skeleton-text :animated="true" style="width: 30%"></ion-skeleton-text>
                    </p>
                </ion-label>
            </ion-item>
        </template>
    </ion-content>
</template>

<script setup lang="ts">
import CostumerForm from "@/components/modals/CostumerForm.vue";
import {
    IonBackButton,
    IonButton,
    IonFabButton,
    IonButtons,
    IonCheckbox,
    IonContent,
    IonHeader,
    IonItem,
    IonLabel,
    IonNavLink,
    IonNote,
    IonRippleEffect,
    IonSearchbar,
    IonSkeletonText,
    IonTitle,
    IonIcon,
    IonItemSliding,
    IonItemOption,
    IonItemOptions,
    IonToolbar,
    IonNav,
    onIonViewWillEnter,
} from "@ionic/vue";
import { add, createOutline } from "ionicons/icons";
import { computed, inject, onMounted, PropType, ref } from "vue";
import { ICostumer } from "@/types/costumer";
import { useInterventionFrequencyStore } from "@/stores/interventionFrequencies";
import { IInterventionFrequency } from "@/types/intervention_frequency";
import InterventionFrequencyForm from "@/components/modals/InterventionFrequencyForm.vue";

const props = defineProps({
    costumer: {
        type: Object as PropType<ICostumer>,
        required: true,
    },
});

const search = ref<string>("");
const navController = inject("navController");
const interventionStore = useInterventionFrequencyStore();
const isInterventionStoreLoading = computed(() => interventionStore.isLoading);
const interventionFrequencies = computed(() => interventionStore.getInterventionFrequencies);
const selectedInterventionFrequency = ref<number | undefined>(props.costumer?.intervention_frequency ?? undefined);
const onFrequencySelect = (interventionFrequency: IInterventionFrequency) => {
    selectedInterventionFrequency.value = interventionFrequency.id;
};

const cleanedData = computed(() => {
    if (selectedInterventionFrequency.value) {
        return {
            costumer: {
                ...props.costumer,
                intervention_frequency: selectedInterventionFrequency.value,
            },
        };
    } else {
        return { costumer: props.costumer };
    }
});

const editInterventionFrequency = (id: number) => {
    // @ts-ignore
    navController.value.$el.push(InterventionFrequencyForm, {
        interventionFrequencyID: id,
    });
};

interventionStore.loadInspectionFrequencies();
</script>

<style scoped></style>
